import CrmDatalayer from './crm.datalayer';
import CronDatalayer from './cron.datalayer';
import MailDatalayer from './mail.datalayer';
import OmsDatalayer from './oms.datalayer';
import PcsDatalayer from './pcs.datalayer';
import EndCustomerGateway from './end-customer-gateway.datalayer';
import SupplierGatewayDatalayer from './supplier-gateway.datalayer';
import ValidooDatalayer from './validoo.datalayer';
import IntegrationDatalayer from './integration.datalayer';
import SettlementDatalayer from './settlement.datalayer';
import AlcoholLicenseDatalayer from './alcohol-license.datalayer';

const datalayers = {
  ...CrmDatalayer,
  ...CronDatalayer,
  ...MailDatalayer,
  ...OmsDatalayer,
  ...PcsDatalayer,
  ...EndCustomerGateway,
  ...SupplierGatewayDatalayer,
  ...ValidooDatalayer,
  ...IntegrationDatalayer,
  ...SettlementDatalayer,
  ...AlcoholLicenseDatalayer,
};

export default datalayers;
